<template>
  <div class="indexAdminLogin_class_div">
    <div class="indexAdminLogin_class_div_row_img" :style="{ backgroundImage: `url(${systemMetaBaseData.systemLoginBackgroundFile != null? systemMetaBaseData.systemLoginBackgroundFile.systemFileUrl:''})` }">
    </div>
    <div class="indexAdminLogin_class_div_row_div">
      <div class="box-card indexAdminLogin_class_div_row">
        <indexAdminLoginInput></indexAdminLoginInput>
      </div>
    </div>
    <!-- <indexAdminLoginFooter></indexAdminLoginFooter> -->
  </div>
</template>

<script setup>
import indexAdminLoginInput from './Data/LoginInput'
import indexAdminLoginFooter from './Data/LoginFooter'
import store from '@/configure/store'

//系统基础数据
const systemMetaBaseData = store.state.systemMetaBaseData

</script>
